import React, { FC } from 'react';

import { MOBILE_PLATFORM, MOBILE_PLATFORM_IDS } from 'src/common/helpers/MobileQueriesHelper';

import './MobilePlatformCellFormatter.scss';

const MOBILE_PLATFORMS_MAP: Record<MOBILE_PLATFORM_IDS, MOBILE_PLATFORM> = {
	[MOBILE_PLATFORM_IDS.ANDROID]: MOBILE_PLATFORM.ANDROID,
	[MOBILE_PLATFORM_IDS.IOS]: MOBILE_PLATFORM.IOS
};

interface IPlatformCellFormatterProps {
	platforms: string[];
}

export const MobilePlatformCellFormatter: FC<IPlatformCellFormatterProps> = ({ platforms }) => {
	if (platforms.length === 0) {
		return null;
	}

	return (
		<div className="mobile-platform-cell-formatter">
			{platforms.map((platform) => (
				<div key={platform}>{MOBILE_PLATFORMS_MAP[platform]}</div>
			))}
		</div>
	);
};
